import { type FC, type ReactNode, useContext } from 'react';

import { ExternalLinkContext } from '../../contexts/external_link';

type Props = {
  href: string;
  className: string;
  children: ReactNode;
  onOpened?: () => void;
};

export const ExternalLink: FC<Props> = ({
  href,
  className,
  children,
  onOpened,
}) => {
  const { openLink } = useContext(ExternalLinkContext);

  return (
    <a
      href={href}
      className={className}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open external link"
      onClick={() => {
        openLink(href);
        if (onOpened) {
          onOpened();
        }
      }}
    >
      {children}
    </a>
  );
};
